import styled from "styled-components";
import BenevvSubmitField from "components/forms/BenevvSubmitField/BenevvSubmitField";

export const OuterContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 1rem;
  box-sizing: border-box;
`;

export const FormContainer = styled.form`
  width: 100%;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
  box-sizing: border-box;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  & > svg {
    cursor: pointer;
    font-size: 1.8rem;
  }
`;

export const PageTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
  position: relative;

  &::after {
    content: "";
    display: block;
    height: 3px;
    background: #fe2f67;
    margin-top: 6px;
    border-radius: 2px;
  }
`;

export const StepWrapper = styled.div`
  display: flex;
  gap: 1rem;
`;

interface StepNumberProps {
  isComplete: boolean;
}

export const StepIndicator = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 30px;
`;

export const StepNumber = styled.div<StepNumberProps>`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fe2f67;
  background-color: ${(p) => (p.isComplete ? "#fe2f67" : "#fff")};
  color: ${(p) => (p.isComplete ? "#fff" : "#fe2f67")};
`;

export const StepLine = styled.div`
  width: 2px;
  background: #c4c4c4;
  flex: 1;
  margin-top: 4px;
`;

export const StepContent = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StepTitle = styled.h3`
  font-weight: 600;
  font-size: 1.2rem;
  margin: 0;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StyledBenevvSubmitField = styled(BenevvSubmitField)`
  padding: 12px 24px;
  font-weight: 600;
  font-size: 1rem;
  background-color: #fe2f67;
  color: #ffffff;
  border-radius: 8px;
  border: none;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:not(:disabled):hover {
    background-color: #e52c5d;
  }
`;
